/**
 * Обгортка, на якій грає зміна масштабу.
 *
 * Окремий компонент, а не `div` на місці, рівно з однієї причини: він
 * мусить стояти **всередині** `Suspense`, а таких місць чотири. Ключ за
 * масштабом лишається тут же, поруч із тим, що він означає.
 *
 * Чому всередині: зовні обгортка монтується разом із заглушкою «Готую…»,
 * анімація грає на ній, а справжній екран приїжджає вже після — тобто
 * миттєвою підміною, рівно тією, заради усунення якої рух і додано.
 * Тиждень, місяць і рік ліниві, тож перший їх показ — саме цей випадок.
 */
import type { HorizonKind } from "@beresta/core";
import type { ReactNode } from "react";
import type { ZoomDirection } from "./zoom.js";

export interface ZoomedProps {
  readonly kind: HorizonKind;
  readonly zoom: ZoomDirection;
  readonly children: ReactNode;
}

export function Zoomed({ kind, zoom, children }: ZoomedProps) {
  /*
   * `key` за масштабом, а не за горизонтом: між днями екран не
   * перемальовується (той самий `DayScreen`), тож ключ не міняється й рух
   * не грає. Між масштабами React однаково монтує інший компонент — ключ
   * не додає жодного зайвого демонтажу, лише дає анімації привід
   * початися.
   */
  return (
    <div className="zoom" key={kind} data-zoom={zoom ?? undefined}>
      {children}
    </div>
  );
}
